define('modules/lp_info/models/page',['require','exports','module','backbone','modules/page_listing/collections/tags','lib/util','env'],function(require, exports, module) {
  'use strict';

  var Backbone = require('backbone'),
      TagCollection = require('modules/page_listing/collections/tags'),
      util = require('lib/util'),
      config = require('env');

  var defaults = {
    full_url: 'to be filled',
    domains_uri: '',
    name: '',
    stats: {},
    published: false,
    id: undefined,
    hidden: false,
    redirect_to_amp: 'none',
    strict_transport_security: false
  };

  var Serialization = {
    parse: function(json) {
      this.tags.reset(json.tags || []);
      var pageJson = _.omit(json, ['tags']);
      return module.exports.__super__.parse.call(this, pageJson);
    },

    toJSON: function() {
      var originalJson = module.exports.__super__.toJSON.call(this);
      return _.extend(originalJson, {
        tags: this.tags.toJSON()
      });
    }
  };

  module.exports = Backbone.Model.extend({
    constructor: function() {
      this.tags = new TagCollection();
      module.exports.__super__.constructor.apply(this, arguments);
    },

    initialize: function() {
      this.listenTo(this.tags, 'add', _.bind(this.trigger, this, 'change:tags'));
      this.listenTo(this.tags, 'remove', this.removeTags);
    },

    defaults: defaults,

    url: function() {
      return [config.apiHost, 'pages', this.id? this.id : this.platform].join('/');
    },

    publish: function() {
      this.save({ published: true }, { patch: true, parse: false });
    },

    unPublish: function() {
      this.save({ published: false }, { patch: true, parse: false });
    },

    removeTags: function() {
      this.save({ tags: this.tags.toJSON() }, { patch: true });
    },

    setRedirectToAMPConfig: function (configValue, cb) {
      if (this.get('redirect_to_amp') !== configValue) {
        this.save({
          redirect_to_amp: configValue
        }, {
          patch: true,
          success: function() {
            cb && cb();
          }
        });
      }
    }
  });

  util.mixin(module.exports, Serialization);
});

